import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { fillHistoryApiConfig } from './fillHistory/constants'
import { fetchApiData as fetchFillHistoryApiData } from './fillHistory/fetchApiData'
import { fundingHistoryApiConfig } from './fundingHistory/constants'
import { fetchApiData as fetchFundingHistoryApiData } from './fundingHistory/fetchApiData'
import { ledgerUpdateHistoryApiConfig } from './ledgerUpdateHistory/constants'
import { fetchApiData as fetchLedgerUpdateHistoryApiData } from './ledgerUpdateHistory/fetchApiData'
import { stakingRewardHistoryApiConfig } from './stakingRewardHistory/constants'
import { fetchApiData as fetchStakingRewardHistoryApiData } from './stakingRewardHistory/fetchApiData'

export const hyperliquidApiConfigs = {
  [fillHistoryApiConfig.type]: fillHistoryApiConfig,
  [fundingHistoryApiConfig.type]: fundingHistoryApiConfig,
  [ledgerUpdateHistoryApiConfig.type]: ledgerUpdateHistoryApiConfig,
  [stakingRewardHistoryApiConfig.type]: stakingRewardHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type HyperliquidApiType = keyof typeof hyperliquidApiConfigs

export const hyperliquidApiTypes = Object.keys(
  hyperliquidApiConfigs,
) as HyperliquidApiType[]

export const fetchHyperliquidApiDataFuncs = {
  [fillHistoryApiConfig.type]: fetchFillHistoryApiData,
  [fundingHistoryApiConfig.type]: fetchFundingHistoryApiData,
  [ledgerUpdateHistoryApiConfig.type]: fetchLedgerUpdateHistoryApiData,
  [stakingRewardHistoryApiConfig.type]: fetchStakingRewardHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchHyperliquidSubTypesFuncs = {
  [fillHistoryApiConfig.type]: undefined,
  [fundingHistoryApiConfig.type]: undefined,
  [ledgerUpdateHistoryApiConfig.type]: undefined,
  [stakingRewardHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentHyperliquidAssets } from './getCurrentAsset'
